export const getRootCNPJ = (cnpj: string) => {
  return cnpj.substring(0, 8);
};